import React from 'react';
import { FilterPanel } from '@src/common/FilterPanelPage/FilterPanel';
import { FilterPanelMain } from '@src/common/FilterPanelPage/FilterPanelMain';
import { ResultsContent } from '@src/common/FilterPanelPage/results/ResultsContent';
import { LinkAnalysisFilterPanel } from './LinkAnalysisFilterPanel';
import { LinkAnalysisResults } from './LinkAnalysisResults';
import { LinkAnalysisLoadingAttr } from './filterPanelComponents/LinkAnalysisLoadingAttr';

export const LinkAnalysisPage = () => {
  return (
    <FilterPanelMain>
      <FilterPanel>
        <LinkAnalysisLoadingAttr />
        <LinkAnalysisFilterPanel />
      </FilterPanel>
      <ResultsContent>
        <LinkAnalysisResults />
      </ResultsContent>
    </FilterPanelMain>
  );
};
